import { render, staticRenderFns } from "./PlotList.vue?vue&type=template&id=32191707&scoped=true&"
import script from "./PlotList.vue?vue&type=script&lang=ts&"
export * from "./PlotList.vue?vue&type=script&lang=ts&"
import style0 from "./PlotList.vue?vue&type=style&index=0&id=32191707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32191707",
  null
  
)

export default component.exports